import { __assign, __rest } from "tslib";
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
var CalendarDatePicker = function (_a) {
    var props = __rest(_a, []);
    return React.createElement(DatePicker, __assign({}, props, { className: "tw-rounded ".concat(props.className) }));
};
export default CalendarDatePicker;
